import { execute, GET, POST, DELETE, PATCH} from "."

const baseUrl = (route='')=> `api/iccs${route}`

export const activateLine = ({$store}, icc) => execute({method:POST, route: baseUrl(`/${icc}/activate`), $store})